import React from "react";
import Route from "./Routes";

function App() {
  return <Route />;
}

export default App;
